import { Component, EventEmitter, Input, Output, ViewContainerRef, ComponentRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/Rx';

import { TestNavigationService } from './../../../services/test-navigation.service';
import { MyModal } from './../../common/my-modal/my-modal.component';
import { TestContentService } from './../../../services/test-content.service';
import { DynamicComponentService } from './../../../services/dynamic-component.service';
import { resolve } from 'url';

@Component({
    selector: 'test-form-validation',
    template: require('./test-form-validation.component.html')
})
export class TestFormValidationComponent {

    private email: string;
    private visible = false;
    private validating = false;
    private viewContainerRef: ViewContainerRef;
    private testFormId: number;
    private bulkTestFormIds: string;
    constructor(
        private testNavigationService: TestNavigationService,
        private testContentService: TestContentService,
        private myModal: MyModal,
        private dynamicComponentService: DynamicComponentService
    ) {}

    showTestForm(viewContainerRef: ViewContainerRef, testFormId: number){
        this.viewContainerRef = viewContainerRef;
        this.testFormId = testFormId;
        this.visible = true;
    }
    
    show(viewContainerRef: ViewContainerRef, bulkTestFormIds: string){ 
        this.viewContainerRef = viewContainerRef;
        this.bulkTestFormIds = bulkTestFormIds;
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }

    private async validate() {
        this.validating = true;
        const displayErrors = [];
        const testletIds = [];
        const errorMessages = [];
        let testlets = [];
        let testFormIdList = [];

        testFormIdList = this.bulkTestFormIds.split(",");
        for (let index = 0; index < testFormIdList.length; index++) {
            await new Promise((resolve,reject) => {
                this.testContentService.getAssessmentTestByTestFormId(testFormIdList[index]).subscribe(assessmentTest => {               
                    const testlet = this.testNavigationService.getTestlets(assessmentTest);
                    testlet.forEach(element => {
                        testlets.push(element);
                    });
                    resolve();             
                });    
            })             
        }
        const distinct = testlets.filter((testlet,index,self) => self.findIndex(t => t.name === testlet.name) === index);       
        let componentRef: ComponentRef<any>;
        Observable.interval(3000)
        .startWith(0)
        .take(distinct.length)
        .subscribe(
            interval => {
                if (componentRef) {
                    componentRef.destroy();
                }
                this.testContentService.getTestlet(distinct[interval].testletId, "0").subscribe(testlet => {
                    testlet.AssessmentItems.forEach((assessmentItem, assessmentItemIdx) => {
                        let html = "";
                        assessmentItem.ItemBody.ItemBodyPanels.forEach(panel => {
                            html += panel.Html;
                        });
                        this.dynamicComponentService.getComponentRef(this.viewContainerRef, html)
                            .then((newComponentRef) => {
                                componentRef = newComponentRef;
                                componentRef.instance.interactions = testlet.AssessmentItems[assessmentItemIdx].Interactions;
                            })
                            .catch(reason => {
                                testletIds.push(distinct[interval].testletId);
                                errorMessages.push(reason.message);
                                displayErrors.push(`<h5>Testlet ID: ${distinct[interval].testletId}, Page: ${assessmentItemIdx + 1}</h5><div style="font-size: 0.9em; color: #777">${reason}</div>`);
                            });
                    });
                });
            },
            error => console.log(error),
            () => {
                if (componentRef) {
                    componentRef.destroy();
                }
                this.hide();
                if (displayErrors.length > 0) {
                    this.myModal.showRegularDlg("The following testlets failed to validate:", displayErrors.join("<hr>"));
                } else {
                    this.myModal.showRegularDlg("Info", "Validation passed.");
                }
                for(var i = 0; i < testFormIdList.length; i++){
                    this.testContentService.sendTestFormValidationResultEmail(testFormIdList[i], testletIds, errorMessages, this.email).subscribe();
                }        
            }
        );

    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/test-form-validation/test-form-validation.component.ts